<template>
  <div class="mainContainer">
    <div class="nav">
      <el-form :model="searchForm" label-width="120px" :inline="true">
        <el-form-item label="委托商：">
          <el-input v-model="searchForm.customer" size="mini" placeholder="请输入委托商" />
        </el-form-item>
        <el-form-item label="供应商：">
          <el-input v-model="searchForm.supplier" size="mini" placeholder="请输入供应商" />
        </el-form-item>
        <el-form-item label="结算类型：">
          <el-select v-model="searchForm.settlementType" size="mini" filterable style="width: 100%" placeholder="请选择结算类型" value-key="id">
            <el-option v-for="item in settlementTypeOptions" :key="item.label" :label="item.label" :value="item.value" />
          </el-select>
        </el-form-item>
        <el-form-item label="港口/库房名称：">
          <el-input v-model="searchForm.name" size="mini" placeholder="请输入港口/库房名称" />
        </el-form-item>
        <el-form-item label="作业类型：">
          <el-select v-model="searchForm.taskTypeId" size="mini" filterable style="width: 100%" placeholder="请选择作业类型" value-key="id">
            <el-option v-for="item in taskTypeOptions" :key="item.id" :label="item.workType" :value="item.id" />
          </el-select>
        </el-form-item>
        <el-form-item label="生成时间：">
          <el-date-picker v-model="creatTime" size="mini" type="daterange" align="right" unlink-panels value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions"> </el-date-picker>
        </el-form-item>
        <el-form-item label="收入是否生成对账单:" label-width="150px">
          <el-select v-model="searchForm.isSrReconciliation" size="mini" placeholder="请选择收入是否生成对账单">
            <el-option label="全部" value="" />
            <el-option label="是" :value="1" />
            <el-option label="否" :value="0" />
          </el-select>
        </el-form-item>
        <el-form-item label="支出是否生成对账单:" label-width="150px">
          <el-select v-model="searchForm.isZcReconciliation" size="mini" placeholder="请选择支出是否生成对账单">
            <el-option label="全部" value="" />
            <el-option label="是" :value="1" />
            <el-option label="否" :value="0" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button size="small" class="searchBtn" @click="searchBtn">查询</el-button>
          <el-button size="small" class="resetBtn" @click="resetBtn">重置</el-button>
          <el-button size="small" class="searchBtn" @click="btnClick('add')">新增</el-button>
          <el-button size="small" class="searchBtn" @click="btnClick('batchSubmission')">批量提交 </el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-row>
      <el-col :span="24" style="text-align: end; font-size: 14px !important" class="exportButton">
        <div style="display: flex; justify-content: flex-end">
          <span @click="download">模板下载</span>
          <batch-import :uploadUrl="uploadUrl" @importSuccess="searchBtn" />
          <span @click="exportData">导出数据</span>
        </div>
      </el-col>
    </el-row>
    <div class="content">
      <el-table ref="registerTable" row-key="id" v-loading="tableLoading" :data="tableData" style="width: 100%" border :header-cell-style="headerCellStyle" @selection-change="selectionChange" :row-style="rowStyle">
        <el-table-column type="selection" align="center" width="50" />
        <el-table-column label="结算类型" prop="settlementType" align="center" :formatter="settlementTypeFormat" width="80" />
        <el-table-column label="委托商" prop="customer" align="center" width="240" />
        <el-table-column label="收入是否生成对账单" prop="isSrReconciliation" align="center" width="150" :formatter="isReconciliation" />
        <el-table-column label="供应商" prop="supplier" align="center" width="240" />
        <el-table-column label="供应商类型" prop="supplierType" align="center" width="240">
          <template slot-scope="scope">
            <span>{{ scope.row.supplierType == 1 ? '公路' : scope.row.supplierType == 2 ? '水路' : scope.row.supplierType == 3 ? '港口及其他' : '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="支出是否生成对账单" prop="isZcReconciliation" align="center" width="150" :formatter="isReconciliation" />
        <el-table-column label="港口/库房名称" prop="name" align="center" width="120" />
        <el-table-column label="作业时间" prop="taskTime" align="center" width="100" />
        <el-table-column label="品牌" prop="brand" align="center" />
        <el-table-column label="委托商作业数量" prop="customerTaskNum" align="center" width="120" />
        <el-table-column label="作业类型" prop="taskType" align="center" width="100" />
        <el-table-column label="供应商作业数量" prop="supplierTaskNum" align="center" width="120" />
        <el-table-column label="生成时间" prop="createTime" align="center" width="180" />
        <el-table-column label="状态" prop="status" align="center" :formatter="statusFormat" />
        <el-table-column label="操作" fixed="right" width="300" align="center">
          <template slot-scope="scope">
            <el-button size="mini" class="searchBtn" @click="btnClick('info', scope.row)">详情 </el-button>
            <el-button v-if="!(scope.row.isCustomerSettlement === 1 || scope.row.isSupplierSettlement === 1 || scope.row.status === 1)" size="mini" class="yellow-bg" @click="btnClick('edit', scope.row)">修改 </el-button>
            <el-button size="mini" class="resetBtn" @click="btnClick('delete', scope.row)">删除 </el-button>
            <el-button v-if="scope.row.status === 0" size="mini" class="searchBtn" @click="btnClick('submit', scope.row)">提交 </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="paginationContainer">
        <el-pagination background :page-sizes="[10, 20, 30, 40]" layout="total, sizes, prev, pager, next, jumper" :total="total" @size-change="contractSizeChange" @current-change="contractCurrentChange" :current-page.sync="searchForm.page" :page-size="searchForm.rows" />
      </div>
    </div>

    <!-- 新增/编辑 -->
    <port-warehouse-charges-form ref="portWarehouseChargesFormRef" @searchBtn="searchBtn" />
    <!-- 详情 -->
    <port-warehouse-charges-info ref="portWarehouseChargesInfoRef" />
  </div>
</template>

<script>
  import PortWarehouseChargesForm from './components/portWarehouseChargesForm';
  import PortWarehouseChargesInfo from './components/portWarehouseChargesInfo';
  import BatchImport from '@/components/batchImport';
  import { getTaskType, portWarehouseCostDel, portWarehouseCostList, portWarehouseCostSubmit } from '@/service/warehouse';
  import { getSessionStore } from '@/config/mUtils';
  import { baseUrl } from '@/config/env';

  export default {
    name: 'portWarehouseCharges',
    components: {
      PortWarehouseChargesForm,
      PortWarehouseChargesInfo,
      BatchImport,
    },
    data() {
      return {
        pickerOptions: {
          shortcuts: [
            {
              text: '最近一周',
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                picker.$emit('pick', [start, end]);
              },
            },
            {
              text: '最近一个月',
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                picker.$emit('pick', [start, end]);
              },
            },
            {
              text: '最近三个月',
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                picker.$emit('pick', [start, end]);
              },
            },
          ],
        },
        searchForm: {
          customer: '',
          supplier: '',
          settlementType: '',
          name: '',
          taskTypeId: '',
          isSrReconciliation: '',
          isZcReconciliation: '',
          page: 1,
          rows: 10,
        },
        creatTime: ['', ''],
        defaultSearchForm: {},
        tableLoading: false,
        tableData: [],
        headerCellStyle: {
          color: '#3B3B3B',
          'font-size': '13px',
          height: '48px',
          background: '#E8E8E8',
        },
        total: 0,
        settlementTypeOptions: [
          {
            value: 0,
            label: '库房',
          },
          {
            value: 1,
            label: '港口',
          },
        ],
        selectedData: [],
        taskTypeOptions: [],
        uploadUrl: '/portWarehouseCost/importExcel',
      };
    },
    mounted() {
      this.defaultSearchForm = JSON.parse(JSON.stringify(this.searchForm));
      // this.searchBtn();
      this.getTaskType();
    },
    methods: {
      async getTaskType() {
        const { status, message, data } = await getTaskType();
        if (status !== 0) return this.$message.warning(message);
        this.taskTypeOptions = [...data['warehouseWork'], ...data['portWork']];
      },
      settlementTypeFormat(row, column, cellValue) {
        switch (cellValue) {
          case 0:
            return '库房';
          case 1:
            return '港口';
        }
      },
      isReconciliation(row, column, cellValue) {
        switch (cellValue) {
          case 0:
            return '否';
          case 1:
            return '是';
          case null:
            return '否';
        }
      },
      // 状态格式化
      statusFormat(row, column, cellValue) {
        switch (cellValue) {
          case 0:
            return '待提交';
          case 1:
            return '已提交';
        }
      },
      // 查询
      searchBtn() {
        this.searchForm.page = 1;
        this.getTableData();
      },
      // 重置
      resetBtn() {
        this.searchForm = JSON.parse(JSON.stringify(this.defaultSearchForm));
        this.creatTime = ['', ''];
      },
      // 获取表格数据
      async getTableData() {
        this.tableLoading = true;
        const { status, message, data } = await portWarehouseCostList({
          ...this.searchForm,
          creatTimeStart: this.creatTime[0] ? this.creatTime[0] : '',
          creatTimeEnd: this.creatTime[1] ? this.creatTime[1] : '',
        });
        this.tableLoading = false;
        if (status !== 0) return this.$message.warning(message);
        this.tableData = data.records;
        this.total = data.total;
      },
      /**
       * 按钮点击
       * @param str 当前按钮标识
       * @param row 当前选中数据
       */
      btnClick(str, row) {
        switch (str) {
          case 'add':
            this.$refs.portWarehouseChargesFormRef.dialogOpen('新增');
            break;
          case 'edit':
            this.$refs.portWarehouseChargesFormRef.dialogOpen('修改', row);
            break;
          case 'info':
            this.$refs.portWarehouseChargesInfoRef.dialogOpen(row.id);
            break;
          case 'batchSubmission':
            if (this.selectedData.length === 0) return this.$message.warning('请选择数据后批量提交');
            const ids = this.selectedData.map(item => item.id);
            this.batchSubmission(ids.join(','));
            break;
          case 'submit':
            this.batchSubmission(row.id);
            break;
          case 'delete':
            this.deleteData(row.id);
            break;
        }
      },
      /**
       * 删除
       * @param id 当前选中数据 id
       */
      deleteData(id) {
        this.$confirm('确认删除当前数据？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            const { status, message } = await portWarehouseCostDel(id);
            if (status !== 0) return this.$message.warning(message);
            this.$message.success(message);
            this.searchBtn();
          })
          .catch(() => {});
      },
      /**
       * 提交/批量提交
       * @param id 当前选中数据 id
       */
      batchSubmission(id) {
        this.$confirm('确认提交当前选中数据？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            const { status, message } = await portWarehouseCostSubmit(id);
            if (status !== 0) return this.$message.warning(message);
            this.$message.success(message);
            this.selectedData = [];
            this.$refs.registerTable.clearSelection();
            this.searchBtn();
          })
          .catch(() => {});
      },
      rowStyle({ row }) {
        return this.selectedData.includes(row) ? { background: 'rgb(197 226 255)' } : {};
      },
      selectionChange(selectionRow) {
        this.selectedData = selectionRow;
      },
      contractSizeChange(row) {
        this.searchForm.rows = row;
        this.searchForm.page = 1;
        this.getTableData();
      },
      contractCurrentChange(page) {
        this.searchForm.page = page;
        this.getTableData();
      },
      //模板下载
      download() {
        window.location.href = '/file/港口库房费用导入模板.xlsx';
      },
      // 导出数据
      exportData() {
        // let token = getSessionStore('token');
        const { customer, supplier, settlementType, name, taskTypeId, isSrReconciliation, isZcReconciliation } = this.searchForm;
        const [creatTimeStart, creatTimeEnd] = this.creatTime;
        // window.location.href = `${baseUrl}/platform/portWarehouseCost/export?access_token=${token}&customer=${customer}&supplier=${supplier}&settlementType=${settlementType}&name=${name}&taskTypeId=${taskTypeId}&creatTimeStart=${creatTimeStart || ''}&creatTimeEnd=${creatTimeEnd || ''}&isSrReconciliation=${isSrReconciliation}&isZcReconciliation=${isZcReconciliation}`;
        window.exportExcelGet('/platform/portWarehouseCost/export', `customer=${customer}&supplier=${supplier}&settlementType=${settlementType}&name=${name}&taskTypeId=${taskTypeId}&creatTimeStart=${creatTimeStart || ''}&creatTimeEnd=${creatTimeEnd || ''}&isSrReconciliation=${isSrReconciliation}&isZcReconciliation=${isZcReconciliation}`);
      },
    },
  };
</script>

<style lang="scss" scoped>
  .mainContainer {
    width: 100%;
    padding: 20px 15px 0 15px;
    background-color: #fff;

    .nav {
      width: 100%;
      display: flex;
      align-items: center;
      flex-wrap: wrap;

      &Btn {
        display: flex;
        align-items: center;
        margin-bottom: 5px;
      }
    }

    .content {
      .paginationContainer {
        margin-right: auto;
        display: flex;
        align-items: center;
        margin-top: 10px;

        span {
          font-size: 13px;
        }
      }
    }
  }
</style>
